import { FormatPrevisaoVendaStatusPipe } from './pipes/format-previsao-venda-status.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { FormatFilterTextPipe } from './pipes/format-filter-text.pipe';
import { FormatCnpjPipe } from './pipes/format-cnpj.pipe';
import { FormatPeriodoAnoMes } from './pipes/format-periodo-ano-mes.pipe';
import { FormatNumberToMonth } from './pipes/format-number-to-month.pipe';
import { FormatAnoMes } from './pipes/format-ano-mes.pipe';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { myFocus } from './directives/focus.directive';
import {SpinnerComponent} from './components/spinner/spinner.component';

import {IMaskModule} from 'angular-imask';
import { ReactiveFormsModule } from '@angular/forms';
import { SideMenuItemComponent } from './components/side-menu-item/side-menu-item.component';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { FormatQuantidadePipe } from './pipes/format-quantidade.pipe';
import { VendedorComboComponent } from './components/vendedor-combo/vendedor-combo.component';
import { ContainerTableComponent } from './components/container-table/container-table.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { UfComboComponent } from './components/uf-combo/uf-combo.component';
import { SetorComboComponent } from './components/setor-combo/setor-combo.component';
import { ComboComponent } from './components/combo/combo.component';
import { CidadeComboComponent } from './components/cidade-combo/cidade-combo.component';
import { BairroComboComponent } from './components/bairro-combo/bairro-combo.component';
import { ButtonComponent } from './components/button/button.component';
import { ModalComponent } from './components/modal/modal.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator'
import {DulorenPaginator} from './directives/DulorenPaginator'
import {MatButtonModule} from '@angular/material/button';
import { MatSortModule } from '@angular/material';
import { CssLoaderComponent } from './components/css-loader/css-loader.component';
import { MaterialTableContainerComponent } from './components/material-table/material-table-container.component';
import { CheckBoxComponent } from './components/check-box/check-box.component';

@NgModule({
  imports: [
    CommonModule,
    IMaskModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    NgbModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatSortModule,
  ],
  declarations: [
    myFocus,
    SpinnerComponent,
    SideMenuItemComponent,
    LoadingIndicatorComponent,
    FormatQuantidadePipe,
    VendedorComboComponent,
    ContainerTableComponent,
    FormFieldComponent,
    UfComboComponent,
    SetorComboComponent,
    ComboComponent,
    CidadeComboComponent,
    BairroComboComponent,
    ButtonComponent,
    FormatAnoMes,
    ModalComponent,
    ModalHeaderComponent,
    FormatNumberToMonth,
    FormatPeriodoAnoMes,
    CssLoaderComponent,
    MaterialTableContainerComponent,
    FormatCnpjPipe,
    FormatFilterTextPipe,
    CheckBoxComponent,
    FormatDatePipe,
    FormatPrevisaoVendaStatusPipe
  ],
  exports: [
    myFocus,
    SpinnerComponent,
    IMaskModule,
    CommonModule,
    ReactiveFormsModule,
    SideMenuItemComponent,
    FontAwesomeModule,
    LoadingIndicatorComponent,
    FormatQuantidadePipe,
    FormsModule,
    VendedorComboComponent,
    ContainerTableComponent,
    FormFieldComponent,
    UfComboComponent,
    SetorComboComponent,
    CidadeComboComponent,
    BairroComboComponent,
    ButtonComponent,
    FormatAnoMes,
    ModalComponent,
    ModalHeaderComponent,
    NgbModule,
    FormatNumberToMonth,
    FormatPeriodoAnoMes,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatSortModule,
    CssLoaderComponent,
    MaterialTableContainerComponent,
    FormatCnpjPipe,
    FormatFilterTextPipe,
    CheckBoxComponent,
    FormatDatePipe,
    FormatPrevisaoVendaStatusPipe
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: DulorenPaginator
    }
  ]
})
export class SharedModule { }
